import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

/** URL segment and translation folder codes supported by the app */
export const SUPPORTED_LOCALES = ["en", "hr", "de", "it", "es", "fr"] as const;

/** CRA `PUBLIC_URL` without trailing slash; empty when hosted at site root. */
const publicPath = (process.env.PUBLIC_URL ?? "").replace(/\/$/, "");

/**
 * i18next path detector uses the Nth pathname segment as the language.
 * At `/en/...` that is index 0; at `/oci-checkin/app/en/...` it must be 2.
 */
function localePathSegmentIndex(): number {
	const trimmed = publicPath.replace(/^\/+/, "");
	if (!trimmed) return 0;
	return trimmed.split("/").filter(Boolean).length;
}

const localeFiles = [
	"navbar",
	"footer",
	"check_in",
	"guest_details",
	"guests_info",
	"guests_navigation_buttons",
	"guest_card",
	"payment",
	"privacy_policy",
	"check_in_complete",
	"scan_doc",
] as const;

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		supportedLngs: [...SUPPORTED_LOCALES],
		ns: [...localeFiles],
		defaultNS: "check_in",
		backend: {
			loadPath: `${publicPath}/locales/{{lng}}/{{ns}}.json`,
		},
		detection: {
			order: ["path", "localStorage", "navigator"],
			caches: ["localStorage"],
			lookupFromPathIndex: localePathSegmentIndex(),
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
